
export const environment = {


	environment_name: 'PROD',
	production: true,
	maintenanceMode: false,
	apiUrl: 'https://api.service.ford.com/sa/esb/external',

	msalConfig: {
    auth: {
      clientId: '6765c9cb-65d7-4041-9b0f-41e6906228ce', // Your application's client id (Application Registration)
      authority: 'https://login.microsoftonline.com/c990bb7a-51f4-439b-bd36-9c07fb1041c0', // Ford's ms tenant. Don't change
    },
    redirectUri: 'https://fordprotect-br.ford.com/home', // This MUST be the same redirect uri you've registered on apicatalog at your webapp scope
    postLogoutRedirectUri: '', // This MUST be the same logout redirect uri you've registered on apicatalog at your webapp scope
  },
  myApiConfig: { // Create the configuration for your API
    scopes: ['api://2cc29358-1285-4857-a591-e010752650c0/webapp'], // Change with your api scope id and scope name
    uri: "https://api.service.ford.com/sa/esb/external" // Your API uri (apigee url)
  }
};
